import React from 'react'
import { observer } from 'mobx-react'

import NoChartData from './NoChartData'
import './derived.scss'

const DerivedChartSlot = ({ store, position, chartKey }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)
    const data = store.getChartDataForQuestion(`${question?.surveyId}-${question?.questionId}-${question?.kpiQuestionId}`, position)

    return (
        <div className="pp-chart-slot-container">
            <div className="pp-derived-slot">
                {question
                    ? store.getChart(
                        {
                            ...data,
                            title: '',
                            containerSize: { height: 400, width: 450 },
                            chartType: 'quadrantAnalysis',
                            kpiType: 'quadrantAnalysis',
                            surveyId: question.surveyId,
                            surveyDefaultLocale: question.surveyDefaultLocale || data?.surveyDefaultLocale,
                            settings: question.settings,
                            key: chartKey,
                            multiQuestion: [
                                { label: 'Correlation', group: '' },
                                { label: data?.widgetRenderSettings?.yAxisTitle || '', group: '' },
                            ],
                        },
                        data?.data,
                    ) || <NoChartData question={question} />
                    : null}
            </div>
        </div>
    )
}

export default observer(DerivedChartSlot)
